// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._16qs1tze{box-shadow:0 0 0 0 var(--ds-background-discovery-bold,#5243aa)}\n._1e0c1nu9{display:inline}\n._1pgl1trn{animation-timing-function:cubic-bezier(.5,0,0,1)}\n._5sagw34l{animation-duration:1.45s}\n._j7hq8j16{animation-name:k1kh5krz}\n._tip811wp{animation-iteration-count:3}\n@keyframes k1kh5krz{to{box-shadow:0 0 0 7px transparent}}", ""]);
// Exports
module.exports = exports;
